import { BlockList, PlacementProvider } from '@zillow/cms-blocks';
import { Box } from '@zillow/constellation';
import React from 'react';

import { PageTemplateProps } from './PageTemplate.types';

const PageTemplate = ({ post }: PageTemplateProps): JSX.Element => {
    return (
        <PlacementProvider placement="page">
            <BlockList blocks={post?.blocks || []} />
            {post?.footer && (
                <Box
                    sx={{
                        margin: '0 auto',
                        padding: '0 $spacing.sm',
                        maxWidth: '$breakpoints.xxl',
                    }}
                >
                    <BlockList blocks={post?.footer?.blocks || []} />
                </Box>
            )}
        </PlacementProvider>
    );
};

export default PageTemplate;
